import React from 'react';
import { Routes, Route } from 'react-router-dom';

// Public Pages
import BlogList from './pages/BlogList';
import BlogDetail from './pages/BlogDetail';

// Admin Pages
import AdminList from './pages/admin/AdminList';
import AdminCreate from './pages/admin/AdminCreate';
import AdminEdit from './pages/admin/AdminEdit';

// Layouts
import PublicLayout from './layouts/PublicLayout';
import AdminLayout from './layouts/AdminLayout';

function App() {
  return (
    <Routes>
      {/* Public Routes */}
      <Route path="/blog" element={<PublicLayout />}>
        <Route index element={<BlogList />} />
        <Route path=":slug" element={<BlogDetail />} />
      </Route>

      {/* Admin Routes */}
      <Route path="/admin/blog" element={<AdminLayout />}>
        <Route index element={<AdminList />} />
        <Route path="create" element={<AdminCreate />} />
        <Route path="edit/:id" element={<AdminEdit />} />
      </Route>

      {/* Redirect root to blog */}
      <Route path="/" element={<PublicLayout />}>
        <Route index element={<BlogList />} />
      </Route>
    </Routes>
  );
}

export default App;
